import React from 'react';
import {
  IdcardOutlined,
  LockOutlined,
  SolutionOutlined,
  UserOutlined,
} from '@ant-design/icons';
import FushaEkspertizes from '../../SettingsModal/FushaEkspertizes';
import RessetPassword from '../../SettingsModal/RessetPassword';
import UserInformation from '../../SettingsModal/UserInformation';
import TedhenaPersonale from '../../SettingsModal/TedhenaPersonale';

export interface SettingsModalItem {
  key: string;
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
}

export const settingsModalItemsData = (
  closeModal: () => void,
): SettingsModalItem[] => [
  {
    key: '1',
    title: 'Perdoruesi',
    icon: <UserOutlined />,
    children: <UserInformation />,
  },
  {
    key: '2',
    title: 'Ndrysho fjalekalimin',
    icon: <LockOutlined />,
    children: <RessetPassword />,
  },
  {
    key: '3',
    title: 'Fusha e ekspertizes',
    icon: <SolutionOutlined />,
    children: <FushaEkspertizes />,
  },
  {
    key: '4',
    title: 'Të dhënat personale',
    icon: <IdcardOutlined />,
    children: <TedhenaPersonale onSuccess={closeModal} />,
  },
];
